module.exports = __webpack_public_path__ + "static/img/receive-icon.df511e5d.png";